import { FeedbackMediaType } from "@amzn/stencil-react-components/customer-satisfaction";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC, useMemo } from "react";

import { CustomerFeedbackModal } from "../CustomerFeedbackModal";

const IMAGE_PATH = "/img/cfm-character.svg";

export interface CustomerFeedbackSheetProps {
  touchpoint: string;
  close: () => void;
}

export const CustomerFeedbackSheet: FC<CustomerFeedbackSheetProps> = ({ touchpoint, close }) => {
  const mediaProps = useMemo(
    () => ({
      media: {
        altText: getString("customerFeedback.sheet.imageAltText"),
        src: IMAGE_PATH,
        type: FeedbackMediaType.IMAGE,
      },
    }),
    []
  );

  return (
    <CustomerFeedbackModal
      touchpoint={touchpoint}
      analyticsEventPrefix="cfm-sheet"
      close={close}
      mediaProps={mediaProps}
    />
  );
};
